import { render, staticRenderFns } from "./ProjectViewSwitcher.vue?vue&type=template&id=dd0b746a&scoped=true"
import script from "./ProjectViewSwitcher.vue?vue&type=script&lang=js"
export * from "./ProjectViewSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ProjectViewSwitcher.vue?vue&type=style&index=0&id=dd0b746a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0b746a",
  null
  
)

export default component.exports